export default {
  doesIncludeSetpoints: 'Jeden Sollwert mit seinen Toleranzen anzeigen',
  doesIncludeSignalLegend: 'Digitale Ausgänge und Bedingungen unter den Schritten auflisten',
};
